import React from 'react'
import ClickOutside from 'react-click-outside'
import ReactDOM from 'react-dom'
import {MdClose} from 'react-icons/md'
import Transition from 'react-transition-group/Transition'
import usePreferencesForAddressContext from '@components/DeliveryWizard/internals/hooks/usePreferencesForAddressContext.main'
import Loading from '@components/Loading'
import NoSSR from '@components/NoSSR'
import SuspenseLoading from '@components/SuspenseLoading'
import classnames from '@helpers/misc/classnames'
import useDisableScroll from '@hooks/useDisableScroll'
import useIsDarkMode from '@hooks/useIsDarkMode'
import useKeyboardEvent from '@hooks/useKeyboardEvent'
import useForcedAddress from '@page-components/Order/Products/useForcedAddress'

import Inner from './Inner'

import styles from './styles.module.css'

export interface SelectProductProps {
  product: {_id?: string}
  close: () => void
  open: boolean
  onAdd?: () => void
  allowEdit?: boolean
  cartItem?: any
}

function SelectProduct(props: SelectProductProps) {
  const {preferences} = usePreferencesForAddressContext()
  const forcedAddress = useForcedAddress()
  const {product, close: closeModal, open} = props

  const handleClose = () => {
    if (!open) return
    closeModal()
  }

  useKeyboardEvent('escape', () => {
    handleClose()
  })

  useDisableScroll(open)
  const isDarkMode = useIsDarkMode()

  const content = (
    <div className={classnames({dark: isDarkMode})}>
      {open ? (
        <style jsx global>{`
          body {
            overflow: hidden;
          }
        `}</style>
      ) : null}
      <Transition in={open} timeout={350}>
        {state => (
          <div className={styles.container + ' ' + styles['container_' + state]}>
            <ClickOutside
              onClickOutside={forcedAddress ? () => {} : handleClose}
              className={styles.dialog + ' ' + styles['dialog_' + state]}>
              {state === 'exited' ? null : (
                <>
                  <div className={styles.close} onClick={handleClose}>
                    <MdClose size={30} className="dark:fill-current text-black" />
                  </div>
                  {product ? (
                    <>
                      <SuspenseLoading>
                        <Inner {...props} />
                      </SuspenseLoading>
                    </>
                  ) : (
                    <div className={styles.center}>
                      <Loading />
                    </div>
                  )}
                </>
              )}
            </ClickOutside>
          </div>
        )}
      </Transition>
    </div>
  )

  return ReactDOM.createPortal(content, document.querySelector('#modal-root'))
}

export default function WrappedSelectProduct(props: SelectProductProps) {
  return (
    <NoSSR>
      <SelectProduct {...props} />
    </NoSSR>
  )
}
